import { FC, PropsWithChildren } from 'react'
import styled from 'styled-components'

const Outer = styled.div`
  background-color: ${({ theme }) => theme['-ds-neutral-200'].value};
  border-radius: 6px;
  padding: 30px;
`

const HelpCard: FC<PropsWithChildren> = ({ children }) => {
  return <Outer>{children}</Outer>
}

export default HelpCard
